import React, { useState, useEffect, useCallback } from "react";
import { Box, Text } from "grommet";
import CheckinFlowService from "../../../services/checkin-flow.service";
import { useTranslation } from "react-i18next";

export default function CheckinFlowDescription({ hotel, communications }) {
  const { i18n } = useTranslation();
  const [lines, setLines] = useState([]);

  const fetchDescription = useCallback(() => {
    if (!hotel?._id) return;
    CheckinFlowService.getFlowDescription(i18n.language).then(
      (res) => setLines(res.data.description || []),
      () => {},
    );
  }, [hotel?._id, i18n.language]);

  // Refresh when hotel config or communications change
  useEffect(() => {
    fetchDescription();
  }, [fetchDescription, hotel]);

  if (!lines.length) return null;

  return (
    <Box background="light-2" round="small" pad="medium" gap="small">
      {lines.map((line, i) => {
        // Parse **bold** segments into spans
        const parts = line.split(/(\*\*[^*]+\*\*)/g);
        return (
          <Text key={i} size="small" color="dark-2">
            {parts.map((part, j) =>
              part.startsWith("**") && part.endsWith("**") ? (
                <strong key={j}>{part.slice(2, -2)}</strong>
              ) : (
                <span key={j}>{part}</span>
              ),
            )}
          </Text>
        );
      })}
    </Box>
  );
}
